@if (((notifications$ | async)?.length ?? 0) > 0 && refError) {
    <button (click)="show('error')" class="button button-bug is-danger">
        <span class="icon is-small">
            <fa-icon [icon]="faCircleExclamation"></fa-icon>
    </span>
    </button>
}

